import { c as _c } from "react/compiler-runtime";
import { AFFILIATE_PROGRAM_API } from 'modules/affiliate-program/api/affiliate-program-api';
import { AffiliateApiInterface, AffiliateFilterInterface } from 'modules/affiliate-program/types/affiliate-program-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { CountInterface, SwrPaginationInterface } from 'shared/types/pagination-interface';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
interface UseAffiliatesInterface extends SwrPaginationInterface {
  filter: AffiliateFilterInterface;
}
export function useAffiliates(t0) {
  const $ = _c(15);
  const {
    limit,
    pagination,
    filter
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  const filterApi = `${filter.dateSince ? `&filter[dateSince]=${filter.dateSince}` : ""}${filter.dateTill ? `&filter[dateTill]=${filter.dateTill}` : ""}${filter.id ? `&filter[id]=${filter.id}` : ""}${filter.email ? `&filter[email]=${filter.email}` : ""}`;
  let t2;
  if ($[1] !== filter.dateSince || $[2] !== filterApi || $[3] !== limit || $[4] !== pagination || $[5] !== user) {
    t2 = () => {
      if (user && pagination.startFromId === undefined && limit && filter.dateSince !== null) {
        return [`${AFFILIATE_PROGRAM_API}/affiliate/list?pagination[limit]=${limit}${filterApi}`, RequestModuleEnum.Contacts];
      } else {
        if (user && pagination.startFromId && limit) {
          return [`${AFFILIATE_PROGRAM_API}/affiliate/list?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`, RequestModuleEnum.Contacts];
        }
      }
      return null;
    };
    $[1] = filter.dateSince;
    $[2] = filterApi;
    $[3] = limit;
    $[4] = pagination;
    $[5] = user;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data: affiliates
  } = useControlledSwr(t2, fetcher);
  let t3;
  if ($[7] !== filter.dateSince || $[8] !== filterApi || $[9] !== pagination || $[10] !== user) {
    t3 = () => {
      if (user && pagination.startFromId === undefined && filter.dateSince !== null) {
        return `${AFFILIATE_PROGRAM_API}/affiliate/count?${filterApi}`;
      }
      return null;
    };
    $[7] = filter.dateSince;
    $[8] = filterApi;
    $[9] = pagination;
    $[10] = user;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const {
    data: affiliatesCounter
  } = useSWR(t3, baseFetcher);
  let t4;
  if ($[12] !== affiliates || $[13] !== affiliatesCounter) {
    t4 = {
      affiliates,
      affiliatesCounter
    };
    $[12] = affiliates;
    $[13] = affiliatesCounter;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}